module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-video-production-ca25a8e09c7016e2274a5e56788c56c8.jpg";